export default {
  sourceRating: (state) => state.sourceRating,
  isLoading: (state) => state.isLoading,
  hasError: (state) => !!state.error,
  error: (state) => state.error,
};
